import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, clearAuthToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [company, setCompany] = useState(null);
  const [legalVersion, setLegalVersion] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    // Optimisation : si aucun token (ni localStorage ni cookie) ET on est sur /login,
    // on saute l'appel /auth/me (évite 401 console + dev overlay CRA).
    let hasToken = false;
    try { hasToken = !!localStorage.getItem("pitboard_session_token"); } catch { /* noop */ }
    if (!hasToken) {
      try { hasToken = /(?:^|; )pb_tk=/.test(document.cookie); } catch { /* noop */ }
    }
    if (!hasToken && window.location.pathname === "/login") {
      setUser(null); setCompany(null); setLegalVersion(null); setLoading(false); return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setCompany(data.company);
      setLegalVersion(data.legal_version || null);
    } catch {
      setUser(null);
      setCompany(null);
      setLegalVersion(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    // AuthCallback will exchange the session_id and establish the session first.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore network errors */ }
    clearAuthToken(); // nettoie le fallback localStorage
    setUser(null);
    setCompany(null);
    setLegalVersion(null);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ user, company, setCompany, legalVersion, loading, refresh: checkAuth, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
